import './SearchBar.css';

export default function SearchBar({ value, onChange, placeholder = 'Search...', className = '' }) {
  return (
    <div className={`ui-search-bar ${className}`}>
      <i className="fas fa-search search-icon"></i>
      <input
        type="text"
        className="ui-input"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
    </div>
  );
}
